import React from 'react';
// @ts-ignore
import StarRatings from 'react-star-ratings';
import { IScore } from '../types.DrawIt';
import { StarWrapper } from '../style.DrawIt';
import { quantifyScore } from '../utils/quantifyScore';
import { appColors } from '../config/colors';
import { Sharing } from '../../sharing/Sharing';
import { Button } from '../../../br24/button/Button';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons';
import { Wrapper } from './style.Result';

interface Props {
    totalCount: number;
    totalScore: IScore[];
}

const getStars = (starsCount: number): string =>
    new Array(5)
        .fill('☆')
        .map((star, i) => (i < starsCount ? '★' : star))
        .join('');

export const Result: React.FC<Props> = ({ totalScore, totalCount }) => {
    const currentCount = totalScore.length;
    const averageStars = currentCount
        ? Math.round((totalScore.reduce((acc, curr) => acc + quantifyScore(curr.score), 0) / currentCount) * 10) / 10
        : 0;

    return (
        <Wrapper>
            <p>
                <strong>
                    Sie haben {currentCount} von {totalCount} Fragen mit durchschnittlich {averageStars} Sternen
                    beantwortet.
                </strong>
            </p>
            <StarWrapper>
                <StarRatings
                    rating={averageStars}
                    starRatedColor={appColors.starBackground}
                    starEmptyColor={appColors.emptyStarBackground}
                    starDimension="2rem"
                    starSpacing="0"
                />
            </StarWrapper>
            <p style={{ marginTop: '1.5rem' }}>Teilen Sie hier Ihr Ergebnis auf Twitter oder Whatsapp:</p>
            <Sharing
                content={{
                    title: 'Merkel nach Zahlen',
                    text: `Zeichnen Sie selbst: Wie hat sich Deutsch­land unter Angela Merkel verändert? Mein Ergebnis ist ${getStars(
                        averageStars
                    )}`
                }}
                iconSize="1.75rem"
                style={{ color: appColors.emptyStarBackground, fontSize: '1rem' }}
                mobileUI={<Button icon={faShareAlt}>Ergebnis teilen</Button>}
            />
        </Wrapper>
    );
};
